import React from "react";
import { Link } from "react-router-dom";
import { fetchAll, deleteOne } from "actions/user";
import { connect } from "react-redux";
import DeleteModal from "components/DeleteModal";
import UpdateUserModal from "components/UpdateUserModal";

const mapStateToProps = state => ({
  users: state.user.byId,
  deleteErrors: state.user.deleteErrors
});

const mapDispatchToProps = {
  fetchAll,
  deleteOne
};

class AdminUserList extends React.Component {
  componentWillMount() {
    this.props.fetchAll();
  }

  render() {
    const users = Object.keys(this.props.users).map(id => this.props.users[id]);
    const { deleteErrors } = this.props;
    return (
      <div>
        <Link to="/admin/user/create">
          <button className="btn btn-danger mb-2">Legg til bruker</button>
        </Link>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Token</th>
              <th scope="col">Firmanavn</th>
              <th scope="col">Lokasjon</th>
              <th scope="col">Handlinger</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.id}>
                <th scope="row">{user.id}</th>
                <td>{user.api_token}</td>
                <td>{user.company}</td>
                <td>{user.location.name}</td>
                <td>
                  <div className="btn-toolbar">
                    <UpdateUserModal
                      onSubmit={this.props.updateOne}
                      title="Endre"
                      user={user}
                    />
                    <DeleteModal
                      errors={deleteErrors}
                      onDelete={this.props.deleteOne}
                      token={user.token}
                      id={user.id}
                      title={user.id + " - " + user.company}
                    >
                      {`Bruker: ${user.id} - ${user.company} på adresse ${
                        user.location.name
                      }`}
                    </DeleteModal>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserList);



// WEBPACK FOOTER //
// ./src/components/AdminUserList.js